(() => {
  const init = () => document.querySelectorAll('[data-rh-contact]').forEach(root => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const message = root.querySelector('[data-rh-message]');
    const count = root.querySelector('[data-rh-count]');
    const hint = root.querySelector('[data-rh-topic-hint]');
    const hints = {
      idea: 'Spune-ne ce produs ai ales, pentru ce eveniment și ce ai vrea să personalizăm.',
      order: 'Adaugă numărul comenzii, dacă îl ai, și spune-ne cu ce te putem ajuta.',
      other: 'Scrie întrebarea ta și detaliile care ne ajută să îți răspundem.'
    };
    root.addEventListener('change', event => {
      if (event.target.matches('[data-rh-topic]')) hint.textContent = hints[event.target.dataset.rhTopic];
    });
    const updateCount = () => { count.textContent = `${message.value.length} / 3.000 de caractere`; };
    message.addEventListener('input', updateCount);
    updateCount();
    // Shopify owns validation, submission, CAPTCHA and the server success state.
    // Never simulate success or disable the submit button during a challenge.
  });
  init();
  document.addEventListener('shopify:section:load', init);
})();
